import { FormBuilder } from "components/FormBuilder/FormBuilder";
import StrongPasswordPopper from "components/StrongPasswordPopper/StrongPasswordPopper";
import React, { useState } from 'react'
import { OnlineMerchantManagement } from "../OnlineMerchantManagement";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";

/**
 * @param {Object} props 
 * @param {string?} props.merchantId
 * @param {import("react-hook-form").UseFormReturn} props.formProps
 * @param {boolean} props.isCreate
 * @param {boolean} props.isEditing
 * @param {boolean} props.isLoading
 */
const OnlineEmployeeFormInfoSection = ({
  formProps,
  merchantId,
  isCreate,
  isEditing,
  isLoading
}) => {
  const { t: tLocal } = useTranslation("translation", { keyPrefix: "form.onlineMerchantManagement.employee.infoSection" });
  const { t: tCommon } = useTranslation();

  const [popperOpen, setPopperOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const isDisabled = isLoading;
  const isReadOnly = !isCreate && !isEditing;
  const password = useWatch({ control: formProps.control, name: "password" });

  /** @type {Record<string, import("components/FormBuilder/lib/FormBuilderFieldBuilder").formBuilderFieldConfig>} */
  const fieldsConfig = {
    merchantId: {
      fieldType: "textInput",
      fieldName: "merchantId",
      label: tLocal("label.merchantId"),
      mandatory: true,
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        defaultValue: merchantId || "",
      },
    },
    name: {
      fieldType: "textInput",
      fieldName: "name",
      label: tLocal("label.name"),
      mandatory: true,
      disabled: isDisabled,
      readOnly: isReadOnly,
    },
    email: {
      fieldType: "textInput",
      fieldName: "email",
      label: tLocal("label.email"),
      mandatory: true,
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        rules: ["validEmail"],
      }
    },
    password: {
      fieldType: "textInput",
      fieldName: "password",
      label: tLocal("label.password"),
      mandatory: true,
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        inputType: "password",
        rules: ["validStrongPassword"],
        customOnFocusFn: (e) => {
          setPopperOpen(true);
          setAnchorEl(e.target);
        },
        customOnBlurFn: () => {
          setPopperOpen(false);
          setAnchorEl(null);
        }
      }
    },
    permission: {
      fieldType: "selection",
      fieldName: "permission",
      label: tLocal("label.permission"),
      disabled: isDisabled,
      readOnly: isReadOnly,
      config: {
        multiSelection: true,
        options: OnlineMerchantManagement.Options.employeePermissions,
      }
    },
    isBoxsPay: {
      fieldType: "checkbox",
      fieldName: "isBoxsPay",
      label: tLocal("label.isBoxsPay"),
      disabled: true,
    }
  }

  return (
    <FormBuilder.Section
      title={tLocal("title")}
      titleVariant="h3"
    >
      <FormBuilder.Row itemsPerRow={2}>
        {
          FormBuilder.buildFields({
            formProps,
            t: tCommon,
            fields: [
              fieldsConfig.merchantId,
              fieldsConfig.name,
              fieldsConfig.email,
              isCreate && fieldsConfig.password,
              fieldsConfig.permission,
              fieldsConfig.isBoxsPay,
            ],
          })
        }
      </FormBuilder.Row>
      <StrongPasswordPopper
        open={popperOpen}
        anchorEl={anchorEl}
        password={password}
      />
    </FormBuilder.Section>
  )
}

export default OnlineEmployeeFormInfoSection
